import { Component, OnInit } from '@angular/core';
import { Subject, of } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CustomDialogService } from '../../custom-dialog.service';
import { NominationsService } from 'src/app/services/nominations.service';
import { SettingsService } from 'src/app/services/settings.service';
import { APIsEndPoints } from 'src/app/utilities/apis.endpoints';

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss']
})
export class CustomDialogComponent implements OnInit {
  actionType: string;
  message: string;
  mainText: any;
  subText: string;
  lastText: string;
  shortList: any[] = [];
  bulkError: any[] = [];
  downloadStatus = 0;
  bulkLinkShow = false;
  showOk = false;
  showCancel = false;
  okTitle = 'OK';
  cancelTitle = 'Cancel';
  successTitle = 'OK';
  submitting = false;

  private actionSubject = new Subject<string>();
  action$ = this.actionSubject.asObservable();

  safetyChampionsSurveyActivePeriod: any;
  comments: any;
  userId: any;
  comment: string;
  voterName: string;
  voterRole: string;
  selectedCandidate: any;
  winnerDeclared = false;
  period: any;
  email: string;

  private setting = {
    element: { dynamicDownload: null as HTMLElement }
  };

  constructor(
    public activeModal: NgbActiveModal,
    public customDialogService: CustomDialogService,
    private router: Router,
    private nominationService: NominationsService,
    private settingService: SettingsService
  ) {
    this.loadSettings();
  }

  ngOnInit(): void {
    
    this.configButtons();
    this.getBulkErrors();
    this.loadSettings();
  }

  private loadUserProfile(): void {
    const storedProfile = localStorage.getItem('userProfile');
    const adminData = storedProfile ? JSON.parse(storedProfile).user : { firstName: '', anotherName: '', roles: [''], email: '' };
    this.voterName = `${adminData.firstName} ${adminData.anotherName}`;
    this.voterRole = adminData.roles[0];
    this.email = adminData.email;
  }

  private loadSettings(): void {
    this.settingService.getSubmitterDetailViewStatus().subscribe((data: any) => {
      if (data) {
        this.settingService.setEmailAddress(data.submitterEmailAddressArray);
        this.settingService.setSafetyChampionsSurveyActiveEmailAddresses(data.submitterSafetyChampionSurveyEmailAddressArray);
        this.settingService.setsafetyChampionsSurveyActivePeriod(data.safetyChampionsSurveyActivePeriod);
        this.period = data.safetyChampionsSurveyActivePeriod;
        this.safetyChampionsSurveyActivePeriod = data.safetyChampionsSurveyActivePeriod;
      }
    });
  }

  getBulkErrors(): void {
    this.bulkError = this.customDialogService.getErrorArray();
    this.bulkLinkShow = this.bulkError.length > 0;
    if (!this.bulkLinkShow) this.customDialogService.setErrorArray([]);
  }

  onCancel(): void {
    this.customDialogService.setErrorArray([]);
    this.actionSubject.next('dismiss');
    this.activeModal.dismiss();
  }

  onOk(): void {
    this.actionSubject.next(this.actionType);
    this.activeModal.dismiss();
    window.location.reload();
  }

  submitCommentAndVote(): void {
    const token = localStorage.getItem('tokenForVoting');
    this.userId = this.mainText._id;
    const voteData = {
      id: this.userId,
      comment: this.comment,
      voterName: this.voterName,
      voterRole: this.voterRole,
      hasvoted: true
    };

    this.nominationService.submitComment(token, voteData).subscribe({
      next: res => console.log('submit comment:', res),
      error: err => console.error('Error:', err)
    });

    this.customDialogService.showSafetyChampionDialog(
      'Comment for Safety Champion', 'Thanks!',
      'You have successfully submitted', 'submitAndShow'
    );
    this.router.navigate([`voting/crew-nominations-listview/${token}`]);
  }

  submitCommentAndVoteByAdmin(): void {
    this.selectedCandidate = this.mainText;
    this.submitCommentByAdmin();
    this.nominationService.declareWinnerForPeriod(this.selectedCandidate);
    this.winnerDeclared = true;

    this.customDialogService.showSafetyChampionDialog(
      'Comment for Safety Champion', 'Thanks!',
      'You have successfully submitted', 'submitAndShow'
    );
    this.router.navigate(['shortlisted/crew-nominations-listview']);
  }

  submitCommentByAdmin(): void {
    this.loadUserProfile();
    const voteData = {
      id: this.selectedCandidate._id,
      period: this.period,
      comment: this.comment,
      voterName: this.voterName,
      voterRole: this.voterRole,
      email: this.email
    };

    this.nominationService.submitCommentByAdmin(voteData).subscribe({
      next: res => console.log('submit comment:', res),
      error: err => console.error('Error:', err)
    });
  }

  configButtons(): void {
    const config = {
      dismiss: () => { this.showOk = false; this.showCancel = true; this.successTitle = 'DONE'; },
      yes: () => { this.showOk = true; this.showCancel = true; this.okTitle = 'Yes'; },
      add: () => { this.showOk = false; this.showCancel = true; this.okTitle = 'Create New'; },
      failedToSubmit: () => { this.showOk = false; this.showCancel = true; this.successTitle = 'OK'; this.bulkLinkShow = false; },
      ratingScale: () => { this.showOk = false; this.showCancel = true; this.successTitle = 'DONE'; },
      email: () => { this.showOk = false; this.showCancel = true; this.okTitle = 'OK'; }
    };

    if (config[this.actionType]) config[this.actionType]();
  }

  downloaErrorLog(): void {
    this.dynamicDownloadTxt(this.bulkError);
  }

  private dynamicDownloadTxt(errorsList: string[]): void {
    this.fakeValidateUserData(errorsList).subscribe(res => {
      if (res) {
        const data = 'Errors list \n' + res.join('\n');
        this.dyanmicDownloadByHtmlTag({ fileName: 'Error Log', text: data });
      }
    });
  }

  private dyanmicDownloadByHtmlTag(arg: { fileName: string, text: string }): void {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.includes('.json') ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);
    element.dispatchEvent(new MouseEvent('click'));
  }

  fakeValidateUserData(errorArray: string[]) {
    return of(errorArray);
  }

  downloadPdf(selectedCandidate: any): void {
    this.nominationService.generateNominationPdf(selectedCandidate, selectedCandidate.nominationDetails, this.comments,"Shortlisted Candidate");
  }

  goBack(): void {
    this.router.navigate(['nominations/crew-nominations-listview']);
  }

  async submitShortlist(): Promise<void> {
    if (this.submitting) return;
    this.submitting = true;

    try {
      const emailData = {
        emails: this.settingService.getSafetyChampionsSurveyActiveEmailAddresses(),
        period: this.settingService.getsafetyChampionsSurveyActivePeriod(),
        expiryMinutes: 10080,
        front_end_url:APIsEndPoints.FRONT_END_URL
      };

      await this.nominationService.updateShortListData(this.shortList).toPromise();
      await this.nominationService.generateEmailLinksForVoting(emailData).toPromise();

      this.customDialogService.showSafetyChampionDialog(
        'Safety Champions Program Period Shortlisted Candidates', 'Thanks!',
        'You have successfully submitted', 'submitAndShow'
      );

    } catch (error) {
      console.error('Error during shortlist submission:', error);
      this.customDialogService.showDialog('Something went wrong. Please try again.', 'dismiss');
    } finally {
      this.submitting = false;
    }
  }

  async deleteNomination(id): Promise<void> {
    try {
       
      await this.nominationService.deleteNominationById(id).toPromise();

      this.customDialogService.showSafetyChampionDialog(
        'Selected candidate deleted successfully', 'Thanks!',
        '', 'deleteMessage'
      );

    } catch (error) {
      console.error('Error during shortlist submission:', error);
      this.customDialogService.showDialog('Something went wrong. Please try again.', 'dismiss');
    } finally {
      this.submitting = false;
    }
  }
 onFileSelected(event: Event, nomination: any): void {
    console.log('File input changed');
    this.errorMsg = '';
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length) {
      this.selectedFile = input.files[0];

      const newFileName = `${nomination.period}_winner_final_report.jpg`;

      // Rename the file
      this.renamedFile = new File([this.selectedFile], newFileName, {
        type: this.selectedFile.type
      });

      // Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(this.renamedFile);

      // Upload image
      //this.uploadImage(nomination);
    }
  }
 selectedFile: File | null = null;
  renamedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  uploadedFileName: string = '';
  errorMsg: string = '';
  async uploadImage(nomination: any): Promise<void> {
    if (!this.renamedFile || !nomination._id) {
      this.errorMsg = 'File or nomination ID missing';
      return;
    }

    const formData = new FormData();
    formData.append('image', this.renamedFile);
    formData.append('id', nomination._id);
    formData.append('period', nomination.period);
    formData.append('captionDetails', this.comment);

    this.nominationService.imageUploadForWinner(nomination._id, formData).subscribe({
      next: (res) => {
        this.uploadedFileName = res.data.imageurl.split('/').pop() || '';
        this.errorMsg = '';
        this.customDialogService.showSafetyChampionDialog(
          'Uploaded image and caption details has been saved',
          'Thanks !',
          'The report has been updated with these details',
          'submitAndShow'
        );
      },
      error: (err) => {
        this.errorMsg = 'Upload failed. Try again!';
        this.customDialogService.showSafetyChampionErrorDialog(
          'Upload failed!',
          'We couldn’t save the image to the system.',
          'Please check your connection and try again',
          'error'
        );
      }
    });
  }

}
